import React from "react";

const Details = () => {
  return (
    <div className="details">
      <div className="container mx-auto">
        <div className="top-title">
          <h3>
            How engineers use the Lucid Visual <br /> Collaboration Suite
          </h3>
        </div>
        <div className="row g-5 pt-60 pb-40">
          <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center content">
            <div>
              <h3>Solve problems as a team</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum
                dolorem eius facere sed odit hic accusamus voluptatum
                cupiditate, corporis ratione quo perspiciatis totam veritatis
                assumenda quibusdam qui, accusantium vel possimus.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <img src="images/body/b2.png" alt="img" />
          </div>
        </div>

        <div className="row g-5 ptb-40">
          <div className="col-lg-6 col-md-6 col-12">
            <img src="images/body/b3.png" alt="img" />
          </div>
          <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center content-mid">
            <div>
              <h3>Solve problems as a team</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum
                dolorem eius facere sed odit hic accusamus voluptatum
                cupiditate, corporis ratione quo perspiciatis totam veritatis
                assumenda quibusdam qui, accusantium vel possimus.
              </p>
            </div>
          </div>
        </div>
        <div className="row g-5 pt-40">
          <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center content">
            <div>
              <h3>Solve problems as a team</h3>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum
                dolorem eius facere sed odit hic accusamus voluptatum
                cupiditate, corporis ratione quo perspiciatis totam veritatis
                assumenda quibusdam qui, accusantium vel possimus.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <img src="images/body/b4.png" alt="img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
